<template>
  <section class="qrs-typography">
    <pageHeader class="mb--0">
      <h2 class="qrs-header-xl mt--0 mb--0">My wellbeing diary - Entries</h2>
    </pageHeader>
    <div>
      <a
        @click="goBack"
        class="govuk-back-link"
        role="button"
        aria-label="go back to the previous screen"
      >
        <strong>Previous</strong>
      </a>
    </div>
    <div class="details__header">
      <span class="details__header__label">Section</span>
      <h3 class="mt--0">{{ statement.title }}</h3>
    </div>

    <!-- <p>{{ statement.answers.length }}</p> -->

    <div v-if="hasData" class="btn__container">
      <label v-if="isMostRecent"
        ><span
          ><strong>{{ infoMessage }}</strong></span
        ></label
      >
      <button
        name="most recent"
        aria-label="most recent symptom scoring entries"
        class="btn__container__action__btn"
        :disabled="isMostRecent"
        title="Most recent"
        @click="mostrecentClick"
      >
        Most recent
        <span class="screen-reader-text">symptom scoring entries</span>
      </button>
    </div>

    <div v-for="(item, index) in chartData" v-bind:key="index">
      <div v-if="displayIndex === index" class="chart-container">
        <barChart :title="statement.title" :data="item" />
      </div>
    </div>
    <div v-if="hasData" class="btn__container mb--48">
      <button
        name="previous"
        aria-label="view previous seven of entries"
        class="btn__container__nav__btn btn__container__nav__btn--left"
        :disabled="disablePrevButton"
        title="View older entries"
        @click="displayIndex++"
      >
        <i
          aria-hidden="true"
          aria-label="arrow left"
          class="fa fa-arrow-left"
        ></i>
        <span class="screen-reader-text">view previous seven of entries</span>
        <!-- Previous 7 -->
      </button>
      <button
        name="next"
        aria-label="view next seven of entries"
        class="btn__container__nav__btn btn__container__nav__btn--right"
        :disabled="disableNextButton"
        title="View new entries"
        @click="displayIndex--"
      >
        <!-- Next 7 -->
        <i
          aria-hidden="true"
          aria-label="arrow right"
          class="fa fa-arrow-right"
        ></i>
        <span class="screen-reader-text">view next seven of entries</span>
      </button>
    </div>
    <div class="mt--24">
      <span style="visibility:hidden;"><p>Multi function button clear</p></span>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      displayIndex: 0,
      statement: {},
    };
  },
  mounted() {
    this.statement = this.$parent.openStatement;
    this.displayIndex = 0;
  },
  computed: {
    isMostRecent: function () {
      let _isMostRecent = false;
      if (
        this.$parent.openStatement != undefined &&
        this.$parent.openStatement.answers != undefined &&
        this.$parent.openStatement.answers.length > 0
      ) {
        if (this.chartData.length > 0) {
          _isMostRecent = this.displayIndex === 0;
        }
      }
      return _isMostRecent;
    },
    hasData: function () {
      return (
        this.$parent.openStatement != undefined &&
        this.$parent.openStatement.answers != undefined &&
        this.$parent.openStatement.answers.length > 0
      );
    },
    infoMessage: function () {
      let message = "";
      let cnt = 7;
      if (
        this.statement != undefined &&
        this.statement.answers != undefined &&
        this.statement.answers.length > 0
      ) {
        if (this.statement.answers.length < cnt) {
          cnt = this.statement.answers.length;
        }
        if (cnt > 0) {
          if (cnt > 1) {
            message = "Last " + cnt + " entries";
          } else {
            message = "Last entry";
          }
        }
      }
      return message;
    },
    disableNextButton: function () {
      return this.displayIndex === 0;
    },
    disablePrevButton: function () {
      return this.displayIndex === this.chartData.length - 1;
    },
    chartData: function () {
      var perChunk = 7; // items per chunk
      let result = [];
      let temparray = [];
      if (
        this.statement != undefined &&
        this.statement.answers != undefined &&
        this.statement.answers.length > 0
      ) {
        this.statement.answers.forEach((e) => {
          if (e.answer === "Not answered") {
            console.log(e.answer);
            temparray.push({ date: e.date, answer: "Not answered" });
          } else {
            temparray.push({ date: e.date, answer: e.answer });
          }
        });

        const chunkcount = Math.ceil(temparray.length / perChunk);
        let cnt = 0;
        for (let i = 0; i < chunkcount; i++) {
          let chunk = [];
          for (let j = 0; j < perChunk; j++) {
            if (cnt < temparray.length) {
              chunk.push({
                date: temparray[cnt].date,
                answer: temparray[cnt].answer,
                tooltip: this.$answerNames[temparray[cnt].answer],
              });
            } else {
              chunk.push({ date: "", answer: "", tooltip: "" });
            }
            cnt++;
          }
          result.push(chunk.reverse());
        }
      }
      return result;
    },
  },
  methods: {
    goBack() {
      // this.$parent.updateDiary(this.$parent.statementAnswers, this.jsonData);
      this.$parent.goTo(this.$MyWellbeingDiary);
    },
    mostrecentClick() {
      this.displayIndex = 0;
    },
  },
};
</script>